module.exports = __webpack_public_path__ + "static/img/m_role.274c7ab.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/role3/cz/m_role.png
// module id = bPD0
// module chunks = 7